import { render, staticRenderFns } from "./price-index.vue?vue&type=template&id=c7446f5c&scoped=true"
import script from "./price-index.vue?vue&type=script&lang=js"
export * from "./price-index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7446f5c",
  null
  
)

export default component.exports